import { render, staticRenderFns } from "./PageCreateUser.vue?vue&type=template&id=903ed706&"
import script from "./PageCreateUser.vue?vue&type=script&lang=js&"
export * from "./PageCreateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports